module.exports = __webpack_public_path__ + "img/10.858d54fe.jpg";